import { render, staticRenderFns } from "./BaseRace.vue?vue&type=template&id=0670eb43&scoped=true"
import script from "./BaseRace.vue?vue&type=script&lang=js"
export * from "./BaseRace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0670eb43",
  null
  
)

export default component.exports